<template>
	<div>
		<div
			class="modal fade product-tags"
			id="addTagToProduct"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
		<div class="modal-dialog modal-lg" role="document">
			<div
				class="modal-content campaign-g-addedit"
				style="width:1000px;height:260px;margin-left:-49px"
			>
				<div class="modal-header" style = "flex: 0 0 auto">
					<h5 class="modal-title" id="exampleModalLongTitle">Add Tags To Product(s)</h5>
					<button type="button" class="close"  aria-label="Close" @click = "hideModal()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>

				<div class="modal-body" style ="padding-top :25px" v-if="isLoadingData">
					<div
					class="spinner-border"
					style="margin:40px auto;display:block;"
					></div>
				</div>

				<div class="modal-body main_form_block" style="margin-top:25px" v-else>

					<div
						v-for="(input, index) in product_tag_list"
						:key="`customTag-${input.type}`"
						class="input wrapper flex items-center form-group row"
					>
						<div class="col-md-3">
							<label for="name">{{getTagLabel(input.type)}} Tag</label>
						</div>
						<div class = "col-md-6">
							<multiselect
								v-model="input.title"
								ref="multiselect"
								:options="[input.title]"
								:placeholder="input.title"
								:disabled = "add_tags[input.type] == 'Edit'"
								track-by="name"
								@tag="addTag($event, input.type,input)"
								open-direction="bottom"
								:taggable="true"
								class="form-control multi-dropdown col-md-12 select_filter"
								:multiple="false"
									>
							</multiselect>
						</div>
						<div class = "col-md-2" >
							<button
								style="color:white;"
								id="delete"
								class="btn btn-primary"
								v-on:click="saveTagsForProducts(input.type,input)"
							>{{ add_tags[input.type] }}</button>
						</div>
					</div>
					<div class="form-group row" >
						<div class="col-md-3">
							<label for="name">New Tag</label>
						</div>
                        <div class = "col-md-3">
                            <multiselect
                                v-model="new_tag"
                                :options="new_tag_options"
                                :searchable="true"
                                ref="multiselect"
                                label="name"
                                track-by="name"
                                :show-labels="false"
                                @tag="addTag($event, 'tag')"
                                open-direction="bottom"
                                :taggable="true"
                                class="form-control multi-dropdown col-md-12 select_filter"
                                :multiple="false"
                                id="newTag"
                                    >
                            </multiselect>
                        </div>

						<div class = "col-md-3" v-if = "new_tag">
							<input
								type="text"
								id="newTagTitle"
								class="new_tag_title"
								style = "padding: 7px 0px 5px 10px;"
								v-model="newTagTitle"
								placeholder="New Tag Title"/>
						</div>
						<div class = "col-md-2" v-if = "new_tag">
							<div v-if = "add_tag == 'Loading'" class="spinner-border"></div>
							<button
								v-else
								style="color:white;"
								id="delete"
								class="btn btn-primary"
								v-on:click="saveTagsForProducts('tagged_product',newTagTitle)"
							>{{add_tag}}</button>
						</div>
					</div>
				</div>

				<div class="modal-footer" style = "flex: 0 0 auto">
					<div class="mt-2" style="text-align: center">
						<button
							type="button"
							class="btn btn-primary"
							@click = "hideModal()"
							>Close
						</button>
					</div>
				</div>

			</div>
		</div>

	</div>
</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "AddTags2",
		components: {
			Multiselect
		},
		props:{
			product:{
				type: Object,
				required: false
			}
		},
		watch:{
			product(){

				if(this.product && this.product!=""){
					this.getProductAddedListData()
				}
			}
		},
		data() {
			return {
				category_tag:null,
				style_tag:null,
				brand_tag:null,
				pg_tag:null,
				new_tag:null,
				update_tag:null,
				newTagTitle:null,
				category_tags_List:[],
				style_tags_List:[],
				brand_tag_list:[],
				pg_tag_list:[],
				add_tag_list:[],
				tag_list:[],
				isLoadingData: false,
				add_cat:'Save',
				add_style:'Save',
				add_brand:'Save',
				add_pg:'Save',
				add_tag:'Save',
				add_tags:[],
				new_tag_options: [],
				input_tag_list:[],
				new_tags: [
					{ name: 'Brand', value: 'brand_product'},
					{ name: 'Category', value: 'category_product'},
					{ name: 'Sub-Category', value: 'sub_category_product'},
					{ name: 'Style', value: 'style_product'},
					{ name: 'Product Group', value: 'product_group_product'},
					{ name: 'Size', value: 'size_product'},
					{ name: 'Flavor', value: 'flavor_product'},
					{ name: 'GL', value: 'gl_product'},
					{ name: 'Competitor', value: 'competitor_product'},
					{ name: 'Color', value: 'color_product'},
					{ name: 'Abbreviated Title', value: 'abbreviated_title_product'},
				]
			};
		},
		computed:{
			selectedProducts: {
				get() {
					return this.$store.state.product.selectedProducts;
				},
				set(val) {
					this.$store.state.product.selectedProducts = val
				}
			},
			actionSelectionControl: {
				set(val) {
					this.$store.state.product.actionSelectionControl = val
				},
				get() {
					return this.$store.state.product.actionSelectionControl
				}
			},
			product_tag_list() {
				let l = this.$store.state.product.tagList
				let inputs = []
				this.new_tag_options = []
				this.input_tag_list = []

				if(l) {
					l.forEach(tag => {
						let input = inputs.find(tag_input => {return (tag_input.type == tag.type)})
						if (!input) {
							tag.value=tag.title
							if(tag.id) {
								this.add_tags[tag.type] = 'Edit'
							}
							inputs.push(tag)
							this.input_tag_list.push({value:tag.type})
						}
				})}
				
				this.new_tags.forEach(tag => {
					let has_input = this.input_tag_list.find(new_input => (new_input.value == tag.value))
					if(!has_input) {
						this.new_tag_options.push(tag)
					}
				})

				console.log(inputs.filter( tag => tag.type === 'abbreviated_title_product').flat())

				let ordered_inputs = [
					inputs.filter( tag => tag.type === 'brand_product'),
					inputs.filter( tag => tag.type === 'category_product'),
					inputs.filter( tag => tag.type === 'sub_category_product'),
					inputs.filter( tag => tag.type === 'style_product'),
					inputs.filter( tag => tag.type === 'product_group_product'),
					inputs.filter( tag => tag.type === 'size_product'),
					inputs.filter( tag => tag.type === 'flavor_product'),
					inputs.filter( tag => tag.type === 'gl_product'),
					inputs.filter( tag => tag.type === 'competitor_product'),
					inputs.filter( tag => tag.type === 'color_product'),
					inputs.filter( tag => tag.type === 'abbreviated_title_product'),
				].flat()
				
				return ordered_inputs
			},
		},
		mounted() {
			this.add_tags['flavor_product'] = 'Save'
			this.add_tags['color_product'] = 'Save'
			this.add_tags['competitor_product'] = 'Save'
			this.add_tags['sub_category_product'] = 'Save'
			this.add_tags['gl_product'] = 'Save'
			this.add_tags['product_group_product'] = 'Save'
			this.add_tags['abbreviated_title_product'] = 'Save'
			this.add_tags['size_product'] = 'Save'
		},
		methods: {
			getTagLabel(data) {
				return this.new_tags.find(tag => tag.value == data).name
			},
			addTag(name, type, input){

				var pay = { title : name, id:''}

				console.log('ADDING_TAG')
				console.log(name,type,input)
				
				if(type == 'tag'){
					this.new_tag = pay
					this.new_tag.title = this.newTagTitle
					this.new_tag.type = this.new_tag.val
					this.add_tag_list.push(pay)
				} else {
					input.id = null
					input.title = name
					input.type = type
					input.value = type
					this.update_tag = input
				}

			},
			getTagsList(){
				console.log('START_TAGS_LIST')
				this.$store.dispatch("product/getTagsForProduct").then((res) => {
					console.log('TAGS_RESPONSE', res)
					this.tag_list = res.tags
				})
			},
			getProductAddedListData(){
				if(this.product && (this.product.category || this.product.brand_tag || this.product.style || this.product.product_group_tag || this.product.gl_tag)){
					let payload = {
						id:this.product.id
					}
					this.isLoadingData = true

					let vm = this
					vm.$store.dispatch("product/getTagsInfo", payload).then((res) => {
						vm.isLoadingData = false;
						res.map((e) => {
							if(e.type == 'category_product'){
								vm.category_tag = e
								vm.add_cat = 'Edit';
							} else if(e.type == 'brand_product'){
								vm.brand_tag = e
								vm.add_brand = 'Edit';
							} else if(e.type == 'style_product'){
								vm.style_tag = e
								vm.add_style = 'Edit';
							} else if(e.type == "product_group_tag"){
								vm.pg_tag = e
								vm.add_pg = 'Edit';
							} else {
								vm.add_tags[e.type] = 'Edit'
							}
						})
					})
				}
			},
			saveTagsForProducts(type,input){
				 let vm = this;
				 
				 let payload = {
					 product_id:this.selectedProducts,
					 type:type,
					 entityType : this.$store.state.product.currentTagProduct.entity_type,
				 }
				 console.log('SAVE_TAGS',type,input)

				 if(this.checkAction(type)){
					 if(type == 'tagged_product'){
						this.new_tag.title = this.newTagTitle
						payload.new_tag = this.new_tag
						payload.new_tag.type = type
						this.add_tag = 'Loading'
						console.log('TAGGED_PR',payload)
					 } else {
						payload.new_tag = input
						payload.new_tag.value = type
						this.add_tags[type] = 'Loading'
					 }
					 this.$store.dispatch("product/addTags", payload ).then((res) => {

						if(type == 'tagged_product'){
							vm.add_tag = 'Save'
							vm.new_tag = ''
							vm.newTagTitle = ''
							this.add_tag_list = []
							this.getTagsList()
						} else {
							vm.add_tags[type] = 'Edit'
							this.$mount();
						}
					 })
				 }
			},
			checkAction(type){

				if(type == 'tagged_product'){
					if(this.add_tag == 'Edit'){
						if(this.new_tag){
							this.new_tag = this.add_tag_list.find(e => e.title == this.new_tag.title)
						}
						this.add_tag = 'Save';
						return false
					}
					else{
						return true
					}
				} else {
					if(this.add_tags[type] == 'Edit'){
						this.update_tag = this.input_tag_list.find(new_input => new_input.value == type)
						this.add_tags[type] = 'Save';
						this.$mount();
						return false
					}
					else{
						return true
					}
				}

			},
			hideModal(type){

				if((this.add_cat == 'Save' && this.category_tag) || (this.add_style == 'Save' && this.style_tag) || (this.add_brand == 'Save' && this.brand_tag) || (this.add_tag == 'Save' && this.new_tag) || (this.add_tag == 'Save' && this.new_tag)){
					let isSaveData = confirm('Are you sure you want to close, please click on save to add the tags')
					if(!isSaveData){
						this.$emit("closeModal", type)
						this.tags = null;
						this.category_tag = null;
						this.brand_tag = null;
						this.style_tag = null
						this.pg_tag = null
						this.new_tag = null
						this.update_tag = null
						this.actionSelectionControl = false;
						this.selectedProducts = []
					}
				}
				else{
					this.$emit("closeModal", type)
					this.tags = null;
					this.category_tag = null;
					this.brand_tag = null;
					this.style_tag = null
					this.pg_tag = null
					this.new_tag = null
					this.update_tag = null
					this.actionSelectionControl = false;
					this.selectedProducts = []
				}

			},
		}
	}

</script>
